
    import {Component, Vue} from 'vue-property-decorator'
    import {Getter} from "vuex-class";
    import {PreRtnOrderInfoDto} from "@/api/shopOrder";

    @Component({
        name: 'ReturnMerchBill',
    })
    export default class ReturnMerchBill extends Vue {
        @Getter returnOrderDtl!: PreRtnOrderInfoDto

        labelWidth = 80
        isFreight = '0' // 是否包含运费， 默认不包含

        created() {
            this.isFreight = this.$route.query.isFreight ? this.$route.query.isFreight as string : '0'
        }
    }
